import { useState } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import { useNotify } from "../../hooks/use-notify";
import { API_RESET_PASSWORD } from "../../utils/api-routes";
import assets from "../../assets";

export const Security = () => {
  const { post } = useApi();
  const { mail } = useSingleton();
  const { toggleNotify } = useNotify();
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePassword = async () => {
    if (!mail) {
      toggleNotify({
        type: "error",
        title: "Error",
        description: "User email not found",
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await post(API_RESET_PASSWORD, { email: mail });
      toggleNotify({
        type: "success",
        title: "Success",
        description:
          response?.data?.message || "Password reset link sent to your email",
      });
    } catch (error) {
      console.error("Change password error:", error);
      toggleNotify({
        type: "error",
        title: "Error",
        description: "Failed to initiate password reset",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="settings-section">
      <div className="section-header">
        <h3>Security</h3>
        <p>Manage your account security and access</p>
      </div>
      <div className="settings-card">
        <section className="security-cards">
          <section className="security-item password">
            <section className="left">
              <div className="icon blue">
                <img src={assets.ic_change_pwd} alt="reset-password" />
              </div>

              <section className="text">
                <h4>Reset Password</h4>
                <span>
                  Receive a link to securely update your account password
                </span>
              </section>
            </section>
            
            <button
              className="btn primary"
              onClick={handleChangePassword}
              disabled={isLoading}
              style={{ display: "flex", alignItems: "center", gap: "8px", opacity: isLoading ? 0.75 : 1, cursor: isLoading ? "not-allowed" : "pointer" }}
            >
              {isLoading && (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}
                >
                  <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
              )}
              {isLoading ? "Sending..." : "Reset Password"}
            </button>
          </section>
        </section>
      </div>
    </section>
  );
};
